<template>
  <v-card
    @click="() => typeof widget.data.link!=='undefined' ? move(widget.data.link) : null"
    v-if="widget.type==='kpiTile'"
    :style="widget.data.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.data.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.data.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.data.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.data.color "
    dark
  >
    <v-card-title class="text-h5">
      {{ widget.data.title }}
    </v-card-title>
    <v-card-actions>
      <v-btn text>
        {{ widget.data.model }} {{ widget.data.prefix }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import router from "@/router";
import baseConfig from '@/../baseConfig'
import axios from "@axios";

export default {
  name: "kpi-tile",
  props: {
    widget: Object
  },
  data(){
    return {
      do:1
    }
  },
  mounted() {
    this.refresh()
  },
  destroyed(){
    this.do=0
    console.log("leave")
  },
  methods: {
    async refresh(){
      setTimeout(this.refresh,parseInt(this.widget.data.time))
      if (this.do){
        let resultAction = this.widget.data.action.includes("http");
        let whereIsAction = ""
        if (resultAction) {
          whereIsAction = this.widget.data.action
        } else {
          whereIsAction = baseConfig.baseUrl + this.widget.data.action
        }

        await axios.get(whereIsAction).then(async r => {
          this.widget.data.model = r.data
        })
      }
    },
    move(link) {
      let result = link.includes("http");
      if (result) {
        window.location.href = link
      } else {
        router.push(link)
      }
    }
  }
}
</script>

<style scoped>

</style>
